(function () {
    'use strict';

    angular
        .module('oddPublicModule')
        .directive('oddComponentPreview', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope        = _.clone(boxTmplScope);

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
                function ($rootScope, $scope, $controller) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/odd/oddPublic/oddComponentPreview.[Template].tpl.html';

                    $controller('BoxTmplController', { $scope: $scope });

                    $scope.mapForComponent = function () {
                        $scope.component = angular.copy($scope.boxModel);

                        if ($scope.component.ODDQuestionLabels) {
                            changeIdsToStrings($scope.component.ODDQuestionLabels, 'ODDQuestionLabelID');
                        }
                        initQuestionAttributeValues($scope.component);
                        initQuestionAttachments($scope.component);
                        updateQuestionChoicesId($scope.component);
                        updateQuestionLabelsIds($scope.component);
                        stripPreAndSuffixes($scope.component);
                    };

                    function initQuestionAttributeValues(component) {
                        _.each(component.ODDQuestionAttributeValues, function (qAttrValue) {
                            component.ODDQuestionAttributeValues[qAttrValue.Code] = qAttrValue.ValueText;
                        });

                        // Multiple Fields
                        _.each(component.ODDQuestionFields, function (qField) {
                            _.each(qField.ODDQuestionAttributeValues, function (qAttrValue) {
                                qField.ODDQuestionAttributeValues[qAttrValue.Code] = qAttrValue.ValueText;
                            });
                        });
                    }

                    function initQuestionAttachments(component) {
                        _.each(component.ODDQuestionAttachments, function (qAttachment) {
                            _.forOwn(qAttachment, function (value, key) {
                                qAttachment[key] = String(value);
                            })
                        });

                        // Multiple Fields
                        _.each(component.ODDQuestionFields, function (qField) {
                            _.each(qField.ODDQuestionAttachments, function (qAttachment) {
                                _.forOwn(qAttachment, function (value, key) {
                                    qAttachment[key] = String(value);
                                })
                            });
                        });
                    }

                    /**
                     * Recursively creates a random id for every question choices
                     * @param obj
                     */
                    function updateQuestionChoicesId(obj) {
                        if (obj.ODDQuestionChoices) {
                            obj.ODDQuestionChoices.forEach(function(choice) {
                                choice.ODDQuestionChoiceID = _.uniqueId('choice_');
                            });
                        }

                        if (obj.ODDQuestionFields) {
                            obj.ODDQuestionFields.forEach(function(field) {
                                updateQuestionChoicesId(field);
                            });
                        }
                    }

                    /**
                     * Recursively creates a copy of all properties prefixed by 'ODD' and suffixed by 'EN'.
                     * @param obj
                     */
                    function stripPreAndSuffixes(obj) {
                        if (obj instanceof Array) {
                            obj.forEach(function(o) {
                                stripPreAndSuffixes(o);
                            })
                        }
                        if (typeof obj !== 'object') return;
                        for (var p in obj) {
                            if (obj.hasOwnProperty(p)) {
                                if (p.substr(-2) === 'EN') {
                                    obj[p.substring(0,p.length-2)] = obj[p];
                                } else if (p.indexOf('ODD') === 0) {
                                    obj[p.substr(3)] = obj[p];
                                }
                                stripPreAndSuffixes(obj[p]);
                            }
                        }
                    }

                    /**
                     * For each element in the object list, change the values in the attribute to String
                     * @param objects {[*]} - list of objects
                     * @param attribute {string} - attribute to convert to string
                     */
                    function changeIdsToStrings(objects, attribute) {
                        objects.forEach(function (object) {
                            object[attribute] = String(object[attribute]);
                        });
                    }

                    /**
                     * Set a random ID for each ODDQuestionLabel item in the component
                     * @param obj
                     */
                    function updateQuestionLabelsIds(obj) {
                        if (obj.ODDQuestionLabels) {
                            obj.ODDQuestionLabels.forEach(function(label) {
                                label.ODDQuestionLabelID = _.uniqueId('label_');
                            });
                        }
                    }
            }],

            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
                
                scope.mapForComponent();

                // Debounce to reduce the number of times this function is executed
                scope.$watch('boxModel', _.debounce(function () {
                    scope.mapForComponent();
                    scope.$apply();
                }, 500), true);
            }
        }
    }
})();